import React from "react";
import useCurrency from "../../../../../hooks/useCurrency";

import {
    Button,
    Card,
    Col,
    Descriptions,
    Divider,
    Row,
    Space,
    Statistic,
    Tag,
    Typography
} from "antd";

import {
    DollarOutlined,
    InboxOutlined,
    ShoppingOutlined,
    CalendarOutlined,
    EnvironmentOutlined
} from "@ant-design/icons";

const {
    Title,
    Text
} = Typography;

const STATUS_COLORS = {
    PENDING: "processing",
    ACCEPTED: "success",
    REJECTED: "error"
};

const ConversationOfferPanel = ({
                                    offer,
                                    isBuyer,
                                    isSeller,
                                    loading,
                                    onModify,
                                    onAccept,
                                    onReject,
                                    currentUserId
                                }) => {

    const { symbol } = useCurrency();

    if (!offer) {
        return null;
    }

    const isMyProposal =
        offer.proposedById === currentUserId;

    const isOtherPartyProposal =
        offer.proposedById &&
        offer.proposedById !== currentUserId;

    const currentUnitPrice =
        offer.proposedUnitPricePerPacket ??
        offer.offeredUnitPricePerPacket;

    const currentQuantity =
        offer.proposedQuantityPerPacket ??
        offer.offeredQuantityPerPacket;

    const currentPackets =
        offer.proposedNumberOfPackets ??
        offer.offeredNumberOfPackets;

    const hasProposal =
        offer.proposedUnitPricePerPacket != null ||
        offer.proposedQuantityPerPacket != null ||
        offer.proposedNumberOfPackets != null;

    const isPending =
        offer.status === "PENDING";

    return (
        <Card
            bordered={false}
            style={{
                margin: 20,
                borderRadius: 12,
                background: "#f6ffed"
            }}
        >

            <Space
                direction="vertical"
                style={{ width: "100%" }}
            >

                <Title
                    level={5}
                    style={{ marginBottom: 0 }}
                >
                    Offre commerciale
                </Title>

                <Text type="secondary">
                    {hasProposal
                        ? "Une nouvelle proposition commerciale est en attente."
                        : "Le vendeur a proposé cette offre commerciale."
                    }
                </Text>

                <Divider />

                <Row gutter={16}>

                    <Col span={8}>
                        <Statistic
                            title="Prix"
                            value={currentUnitPrice}
                            precision={0}
                            prefix={<DollarOutlined />}
                            suffix={
                                offer.currency || symbol()
                            }
                        />
                    </Col>

                    <Col span={8}>
                        <Statistic
                            title="Quantité / paquet"
                            value={currentQuantity}
                            precision={2}
                            prefix={<ShoppingOutlined />}
                            suffix={
                                offer.measurementUnit || ""
                            }
                        />
                    </Col>

                    <Col span={8}>
                        <Statistic
                            title="Nombre de paquets"
                            value={currentPackets}
                            precision={0}
                            prefix={<InboxOutlined />}
                            suffix="paquets"
                        />
                    </Col>

                </Row>

                <Divider />

                <Descriptions
                    bordered
                    column={1}
                    size="small"
                >

                    <Descriptions.Item label="Statut">
                        <Tag
                            color={
                                STATUS_COLORS[
                                    offer.status
                                    ] || "default"
                            }
                        >
                            {offer.status}
                        </Tag>
                    </Descriptions.Item>

                    {offer.commercialTerms && (
                        <Descriptions.Item label="Conditions commerciales">
                            {offer.commercialTerms}
                        </Descriptions.Item>
                    )}

                    {offer.expectedDeliveryDate && (
                        <Descriptions.Item label="Livraison prévue">
                            <Space>
                                <CalendarOutlined />
                                {new Date(
                                    offer.expectedDeliveryDate
                                ).toLocaleDateString("fr-FR")}
                            </Space>
                        </Descriptions.Item>
                    )}

                    {offer.deliveryLocation && (
                        <Descriptions.Item label="Lieu de livraison">
                            <Space>
                                <EnvironmentOutlined />
                                {offer.deliveryLocation}
                            </Space>
                        </Descriptions.Item>
                    )}

                    <Descriptions.Item label="Proposée le">
                        {new Date(
                            offer.createdAt
                        ).toLocaleString("fr-FR")}
                    </Descriptions.Item>

                    {offer.updatedAt &&
                        offer.updatedAt !== offer.createdAt && (
                            <Descriptions.Item label="Dernière modification">
                                {new Date(
                                    offer.updatedAt
                                ).toLocaleString("fr-FR")}
                            </Descriptions.Item>
                        )}

                </Descriptions>

                {isPending && (isBuyer || isSeller) && (
                    <>
                        <Divider />

                        <Space wrap>

                            <Button
                                loading={loading}
                                onClick={onModify}
                            >
                                Modifier
                            </Button>

                            <Button
                                type="primary"
                                loading={loading}
                                onClick={onAccept}
                            >
                                Accepter
                            </Button>

                            <Button
                                danger
                                loading={loading}
                                onClick={onReject}
                            >
                                Décliner
                            </Button>

                        </Space>
                    </>
                )}

                {isPending && isOtherPartyProposal && (
                    <>
                        <Button onClick={onModify}>
                            Modifier
                        </Button>

                        <Button
                            type="primary"
                            onClick={onAccept}
                        >
                            Accepter
                        </Button>

                        <Button
                            danger
                            onClick={onReject}
                        >
                            Décliner
                        </Button>
                    </>
                )}

                {isPending && isMyProposal && (
                    <Text type="secondary">
                        Votre proposition est en attente de réponse.
                    </Text>
                )}

            </Space>

        </Card>
    );
};

export default ConversationOfferPanel;